const normalizeSearchText = (text) => text.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');

export function containsText(text, searchTerm) {
  return normalizeSearchText(text).includes(normalizeSearchText(searchTerm));
}

export function userFilter(fullName, searchTerm) {
  const nameParts = fullName.toLowerCase().split(' ');
  const searchTermParts = searchTerm.toLowerCase().split(' ');
  return searchTermParts.every(searchTermPart => nameParts.some(namePart => namePart.includes(searchTermPart)));
}